<div class="modal-header">
  <h4 class="modal-title">{{PageTitle}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="container">
    <div class="contentarea">
      <div class="row mt-3 mb-2">
        <!-- <div class="col-xl-4 col-md-3 col-sm-12 col-12">
          <h5 class="text-primary">{{PageTitle}}</h5>
        </div> -->
        <div class="col-xl-8 col-md-9 col-sm-12 col-12">
          <div class="">
            <form class="form-inline float-lg-right float-sm-left my-2 my-lg-0 ">
              <div class="ml-1 form-group">
                <span class="float-right">
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="container mt-4">
        <div class="row">
          <div class="col-xl-12 p-0">
            <div class="card shadow">
              <div class="card-body">
                <div id="accordion" class="accordion" *ngFor="let survey of result; trackBy: trackByIndex; let i=index">
                  <div class="card mb-0">
                    <div class="card-header  p-2 coloropacity">
                      <span class="acicon collapsed" data-toggle="collapse" [attr.data-target]="'#collapseOne'+(i+1)"
                        [id]="'headingOne'+(i+1)">
                        <span class="m-0">
                          {{survey.surveyLang.length>lin ?survey.surveyLang[lin].langStr:'' }}</span>
                      </span>
                      <span class="float-end" title="Add New Section">
                        <span class="">
                          <!--*ngIf="checkPermission('addNewSection')"-->
                          <a *ngIf="checkPermission('addNewSection')" class="card-title btn btn-sm m-0 btn-success"
                            (click)="addEntity(2,survey.id)" data-toggle="modal" data-target="#form">
                            <i class="fa fa-plus text-white"></i>
                          </a>
                        </span>
                        <span class="" title="Delete Survey">
                          <!--*ngIf="checkPermission('deleteSurvey')"-->
                          <a *ngIf="checkPermission('deleteSurvey')" class="card-title btn btn-sm m-0 btn-danger"
                            (click)="deleteRecord(survey.id,1)" data-toggle="modal" data-target="#form1">
                            <i class="fa fa-trash text-white"></i>
                          </a>
                        </span>
                        <span class="" title="Edit Survey">
                          <!--*ngIf="checkPermission('editSurvey')"-->
                          <a *ngIf="checkPermission('editSurvey')"
                            class="card-title btn btn-sm m-0 btn-primary btnrounded" (click)="editEntity(survey,1)">
                            <i class="fa fa-edit text-white"></i>
                          </a>
                        </span>
                      </span>
                    </div>
                    <div [attr.aria-labelledby]="'headingOne'+(i+1)" [id]="'collapseOne'+(i+1)"
                      class="card-body collapse" data-parent="#accordion">
                      <!--   Second -->
                      <div *ngIf="survey.sections.length > 0">
                        <div id="accordion2" class="accordion"
                          *ngFor="let section of survey.sections;trackBy: trackByIndex;let j=index">
                          <div class="card mb-0">
                            <div class="card-header  p-2">
                              <span class="acicon collapsed" data-toggle="collapse"
                                [attr.data-target]="'#collapseTwo_'+(i+1)+'_'+(j+1)"
                                [id]="'headingTwo_'+(i+1)+'_'+(j+1)">
                                <span class="m-0">
                                  {{(section.sectionLang.length>lin)?section.sectionLang[lin].langStr:'' }} </span>
                              </span>
                              <span class="float-right">

                                <span class="" title="Add New Question">
                                  <!--*ngIf="checkPermission('addQuestion')"-->

                                  <a *ngIf="checkPermission('addQuestion')"
                                    class="card-title btn btn-sm m-0 btn-success"
                                    (click)="addEntity(3,section.id,survey.id)" data-toggle="modal" data-target="#form">
                                    <i class="fa fa-plus text-white"></i>
                                  </a>
                                </span>
                                <span class="" title="Delete Section">
                                  <!--*ngIf="checkPermission('deleteSection')"-->
                                  <a *ngIf="checkPermission('deleteSection')"
                                    class="card-title btn btn-sm m-0 btn-danger" (click)="deleteRecord(section.id,2)"
                                    data-toggle="modal" data-target="#form1">
                                    <i class="fa fa-trash text-white"></i>
                                  </a>
                                </span>
                                <span class="" title="Edit Section">
                                  <!--*ngIf="checkPermission('editSection')"-->

                                  <a *ngIf="checkPermission('editSection')"
                                    class="card-title btn btn-sm m-0 btn-primary " (click)="editEntity(section,2)">
                                    <i class="fa fa-edit text-white"></i>
                                  </a>
                                </span>
                              </span>
                            </div>
                            <div [attr.aria-labelledby]="'headingTwo_'+(i+1)+'_'+(j+1)"
                              [id]="'collapseTwo_'+(i+1)+'_'+(j+1)" class="card-body collapse"
                              data-parent="#accordion2">

                              <!-- third -->
                              <div id="accordion3" class="accordion" *ngIf="section.questions.length > 0">
                                <div class="card mb-0"
                                  *ngFor="let question of section.questions;trackBy: trackByIndex;let k=index">
                                  <div class="card-header  p-2">
                                    <span class="acicon collapsed" data-toggle="collapse"
                                      [attr.data-target]="'#collapseThree'+(k+1)" [id]="'headingThree'+(k+1)">
                                      <span class="m-0">
                                        {{(question.questionLang.length>lin)?question.questionLang[lin].langStr:'' }}
                                      </span>
                                    </span>
                                    <span class="float-right">
                                      <span class="" title="Add New Answer">
                                        <!--*ngIf="checkPermission('addAnswer')"-->
                                        <a *ngIf="checkPermission('addAnswer')"
                                          class="card-title btn btn-sm m-0 btn-success "
                                          (click)="addEntity(4,question.id)" data-toggle="modal" data-target="#form">
                                          <i class="fa fa-plus text-white"></i>
                                        </a>
                                      </span>
                                      <span class="" title="Delete Question">
                                        <!--*ngIf="checkPermission('deleteQuestion')"-->
                                        <a *ngIf="checkPermission('deleteQuestion')"
                                          class="card-title btn btn-sm m-0 btn-danger "
                                          (click)="deleteRecord(question.id,3)" data-toggle="modal"
                                          data-target="#form1">
                                          <i class="fa fa-trash text-white"></i>
                                        </a>
                                      </span>
                                      <span class="" title="Edit Question">
                                        <!--*ngIf="checkPermission('editQuestion')"-->
                                        <a *ngIf="checkPermission('editQuestion')"
                                          class="card-title btn btn-sm m-0 btn-primary "
                                          (click)="editEntity(question,3,survey.id)">
                                          <i class="fa fa-edit text-white"></i>
                                        </a>
                                      </span>
                                    </span>
                                  </div>
                                  <div [attr.aria-labelledby]="'headingThree'+(k+1)" [id]="'collapseThree'+(k+1)"
                                    class="card-body collapse" data-parent="#accordion3">

                                    <!-- fourth -->
                                    <div class="container">
                                      <div>
                                        <div class="card mb-0"
                                          *ngFor="let answer of question.answers;trackBy: trackByIndex;let l=index">
                                          <div class="card-header  p-2">
                                            <span>
                                              <span class="m-0"> {{(answer.answerLang.length>lin)?
                                                answer.answerLang[lin].langStr:'' }}</span>
                                            </span>
                                            <span class="float-right">
                                              <span class="" title="Delete Answer">
                                                <!--*ngIf="checkPermission('deleteAnswer')"-->
                                                <a *ngIf="checkPermission('deleteAnswer')"
                                                  class="card-title btn btn-sm m-0 btn-danger "
                                                  (click)="deleteRecord(answer.id,4)" data-toggle="modal"
                                                  data-target="#form1">
                                                  <i class="fa fa-trash text-white"></i>
                                                </a>
                                              </span>
                                              <span class="" title="Edit Answer">
                                                <!--*ngIf="checkPermission('editAnswer')"-->
                                                <a *ngIf="checkPermission('editAnswer')"
                                                  class="card-title btn btn-sm m-0 btn-primary"
                                                  (click)="editEntity(answer,4)">
                                                  <i class="fa fa-edit text-white"></i>
                                                </a>
                                              </span>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" id="saveButton" class="btn btn-primary btn-sm">Save</button>

  <button type="button" id="closeButton" class="btn btn-outline-dark btn-sm"
    (click)="activeModal.close('Close click')">Close</button>
</div>




<!-- modal -->


<div class="modal fade" id="myModal" data-backdrop="static" data-keyboard="false" tabindex="-1"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content">
      <div class="modal-header" *ngIf="modelType==1">
        <h5 class="modal-title" id="exampleModalLabel">{{mode}} Survey</h5>
        <button type="button" class="close" aria-label="Close" data-dismiss="modal" (click)="closeWindow()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="modelType==1">
        <div class="container mt-0">
          <div class="form-group">
            <div class="row mb-2">

              <div class="col-xl-3">
                <label><span>Survey Order</span></label>
              </div>
              <div class="col-xl-3">
                <div class="text-effect">
                  <!-- <input type="text" class="form-control form-control-sm focus-text" onkeypress='return (event.charCode >= 48 && event.charCode <= 57)'
                         [(ngModel)]="serveyEntity?.surveyOrder"  maxlength="3" id="surveyOrder" autocomplete="nope" />
                    </div> -->
                </div>
                <div class="col-xl-3">
                  <label>Target SurveyId</label>
                </div>
                <div class="col-xl-3">
                  <!-- <div class="group">
                        <select class="form-control form-control-sm" [(ngModel)]="serveyEntity?.tragetSurveyId">
                          <option value="null">Select</option>
                          <option *ngFor="let survey of records1" [value]="survey.id">{{survey.id}}</option>
                        </select>
                      </div> -->
                </div>
                <br>
              </div>
              <div *ngFor="let srvy of serveyEntity.surveyLang;  let i=index">
                <div *ngIf="supportedLanguages.length > i">
                  <div class="row mb-2">
                    <div class="col-xl-3">
                      <label>{{supportedLanguages.length > i ? supportedLanguages[i].name : ''}}</label>
                    </div>
                    <div class="col-xl-9">
                      <div class="text-effect">
                        <input type="text" class="form-control form-control-sm focus-text" pattern="[a-zA-Z][a-zA-Z ]+"
                          [(ngModel)]="srvy.langStr" maxlength="100" id="langStr" autocomplete="nope" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br>
            </div>
          </div>
        </div>
        </div>
        <div class="modal-header border-bottom-0" *ngIf="modelType==2">
          <h5 class="modal-title ml-2" id="exampleModalLabel">{{mode}} Section</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span
              aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body pt-0 pb-0 small" *ngIf="modelType==2">
          <div class="container mt-0">
            <div class="form-group">
              <div class="row mb-2">
                <div class="col-xl-3">
                  <label><span>Section Order</span></label>
                </div>
                <div class="col-xl-3">
                  <div class="text-effect">
                    <input type="text" class="form-control form-control-sm focus-text"
                      onkeypress='return (event.charCode >= 48 && event.charCode <= 57)'
                      [(ngModel)]="sectionEntity.sectionOrder" maxlength="5" id="sectionOrder" autocomplete="nope" />
                  </div>
                </div>
                <br>
              </div>
              <div *ngFor="let sect of sectionEntity.sectionLang;  let i=index">
                <div *ngIf="supportedLanguages.length > i">
                  <div class="row mb-2">
                    <div class="col-xl-3">
                      <label>{{supportedLanguages.length > i ? supportedLanguages[i].name : ''}}</label>
                    </div>
                    <div class="col-xl-9">
                      <div class="text-effect">
                        <input type="text" class="form-control form-control-sm focus-text" pattern="[a-zA-Z][a-zA-Z ]+"
                          [(ngModel)]="sect.langStr" maxlength="100" id="langStr" autocomplete="nope" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-header border-bottom-0" *ngIf="modelType==3">
          <h5 class="modal-title ml-2" id="exampleModalLabel">{{mode}} Questions</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span
              aria-hidden="true">&times;</span> </button>
        </div>
        <div class="modal-body pt-0 pb-0 small" *ngIf="modelType==3">
          <div class="container mt-0">
            <div class="form-group">
              <div class="row mb-2">
                <div class="col-xl-3">
                  <label><span>Question Order</span></label>
                </div>
                <div class="col-xl-3">
                  <div class="text-effect">
                    <input type="text" class="form-control form-control-sm focus-text"
                      onkeypress='return (event.charCode >= 48 && event.charCode <= 57)'
                      [(ngModel)]="questionEntity.questionOrder" maxlength="3" id="sectionOrder" autocomplete="nope" />
                  </div>
                </div>
                <div class="col-xl-3">
                  <label><span class="text-danger">*</span>Answer Type</label>
                </div>
                <div class="col-xl-3">
                  <div class="group">
                    <select class="form-control form-control-sm" [(ngModel)]="questionEntity.answerType.id">
                      <option value=0>Select</option>
                      <option *ngFor="let ans of ansLst" [value]="ans.id">{{ans.name}}</option>
                    </select>
                  </div>
                </div>
                <br>
              </div>
              <div class="row mb-2">
                <div class="col-xl-3">
                  <label><span>Regular Expression</span></label>
                </div>
                <div class="col-xl-3">
                  <div class="text-effect">
                    <input type="text" class="form-control form-control-sm focus-text"
                      onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
                          (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57)||event.charCode==32)' pattern="[a-zA-Z][a-zA-Z ]+"
                      [(ngModel)]="questionEntity.regularExpression" maxlength="20" id="sectionOrder"
                      [attr.disabled]="questionEntity.answerType.id!=4?true:null" autocomplete="nope"
                      title="ex: For Systolic(mmHg) = ^([0]?|[5-8][0-9]|9[0-9]|[12][0-9]{2}|300)$, For Diastolic(mmHg) = ^([0]?|[3-8][0-9]|9[0-9]|1[0-9]{2}|200)$" />
                  </div>
                </div>
                <div class="col-xl-3">
                  <label>Mandatory</label>
                </div>
                <div class="col-xl-3">
                  <div class="form-group mb-0">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" name="manditory" id="manditory1" class="custom-control-input"
                        [(ngModel)]="questionEntity.mandatory" [value]='true' />
                      <label class="custom-control-label customlabel" for="manditory1">true</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" name="manditory" id="manditory2" class="custom-control-input"
                        [(ngModel)]="questionEntity.mandatory" [value]='false' />
                      <label class="custom-control-label customlabel" for="manditory2">false
                      </label>
                    </div>
                  </div>
                </div>
                <br>
              </div>
              <div class="row mb-2">
                <div class="col-xl-3">
                  <label><span>Special Handling</span></label>
                </div>
                <div class="col-xl-3">
                  <div class="form-group mb-0">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" name="specialHandling" id="specialHandling1" class="custom-control-input"
                        [(ngModel)]="questionEntity.specialHandling" [value]='true' />
                      <label class="custom-control-label customlabel" for="specialHandling1">true</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" name="specialHandling" id="specialHandling2" class="custom-control-input"
                        [(ngModel)]="questionEntity.specialHandling" [value]='false' />
                      <label class="custom-control-label customlabel" for="specialHandling2">false
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3">
                  <label>Show Score</label>
                </div>
                <div class="col-xl-3">
                  <div class="form-group mb-0">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" name="showScore" id="showScore1" class="custom-control-input"
                        [(ngModel)]="questionEntity.showScore" [value]='true' />
                      <label class="custom-control-label customlabel" for="showScore1">true</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" name="showScore" id="showScore2" class="custom-control-input"
                        [(ngModel)]="questionEntity.showScore" [value]='false' />
                      <label class="custom-control-label customlabel" for="showScore2">false
                      </label>
                    </div>
                  </div>
                </div>
                <br>
              </div>
              <div class="row mb-2">
                <div class="col-xl-3">
                  <label><span>Place Holder</span></label>
                </div>
                <div class="col-xl-9">
                  <div class="text-effect">
                    <input type="text" class="form-control form-control-sm focus-text"
                      onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
                          (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57)||event.charCode==32)' pattern="[a-zA-Z][a-zA-Z ]+"
                      [(ngModel)]="questionEntity.placeHolder" maxlength="100" id="placeholder"
                      [attr.disabled]="questionEntity.answerType.id!=4?true:null" autocomplete="nope" />
                  </div>
                </div>
              </div>
              <hr>
              <div class="row mb-2" style="padding-left: 1%">
                <h6>Question Dependency</h6>
              </div>
              <div class="row mb-2">
                <div class="col-xl-3" style="padding-left: 40px">
                  <label><span>Target Question</span></label>
                </div>
                <div class="col-xl-9">
                  <div class="group">
                    <select class="form-control form-control-sm" [(ngModel)]="questionEntity.targetquestionID"
                      (change)="targtQsnChange($event.target.value)">
                      <option value="0">Select</option>
                      <option *ngFor="let ans of targetQsnId" [value]="ans.id">{{ans.series}}. {{ans.name.length > lin ?
                        ans.name[lin].langStr: ''}}</option>
                    </select>
                  </div>
                </div>
                <br>
              </div>
              <div class="row mb-2">
                <div class="col-xl-3" style="padding-left: 40px">
                  <label>Target Answer</label>
                </div>
                <div class="col-xl-9">
                  <div class="group">
                    <select class="form-control form-control-sm" [(ngModel)]="questionEntity.targetanswerID">
                      <option value="0">Select</option>
                      <option *ngFor="let ans of targetAnsId" [value]="ans.id">{{ans.name.length > lin ?
                        ans.name[lin].langStr: ''}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <hr>
              <div class="row mb-2">
                <div class="col-xl-3">
                  <label><span>Question Series</span></label>
                </div>
                <div class="col-xl-3">
                  <div class="text-effect">
                    <input type="text" class="form-control form-control-sm focus-text"
                      onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
                            (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57)||event.charCode==32)' pattern="[a-zA-Z][a-zA-Z ]+"
                      [(ngModel)]="questionEntity.questionSeries" maxlength="3" id="sectionOrder" autocomplete="nope" />
                  </div>
                </div>
                <div class="col-xl-3">
                  <label>Question applicable to (Gender):</label>
                </div>
                <div class="col-xl-3">
                  <div class="group">
                    <select class="form-control form-control-sm" [(ngModel)]="questionEntity.gender">
                      <option value="0">Select</option>
                      <option *ngFor="let ans of genderlst" [value]="ans.id">{{ans.name}}</option>
                    </select>
                  </div>
                </div>
                <br>
              </div>
              <br>
              <div class="row mb-2">
                <table class="table table-sm table-striped  table-bordered  rounded  mb-0  table-fixed">
                  <thead style="text-align: center">
                    <th scope="col">Languages</th>
                    <th scope="col">Question</th>
                    <th scope="col">Summary Label</th>
                  </thead>
                  <tbody>
                    <tr *ngFor="let qstn of questionEntity.questionLang;  let i=index">
                      <td style="text-align: center" *ngIf="supportedLanguages.length > i">
                        <label><strong>{{supportedLanguages.length > i ? supportedLanguages[i].name :
                            ''}}</strong></label>
                      </td>
                      <td *ngIf="supportedLanguages.length > i"><input type="text"
                          class="form-control form-control-sm focus-text" placeholder="Add Question"
                          pattern="[a-zA-Z][a-zA-Z ]+" [(ngModel)]="qstn.langStr" maxlength="100" id="langStr"
                          autocomplete="nope" /></td>
                      <td *ngIf="supportedLanguages.length > i"><input type="text"
                          class="form-control form-control-sm focus-text" placeholder="Add Summary Label"
                          pattern="[a-zA-Z][a-zA-Z ]+" [(ngModel)]="qstn.summary" maxlength="100" id="summary"
                          autocomplete="nope" /></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-header border-bottom-0" *ngIf="modelType==4">
          <h5 class="modal-title ml-2" id="exampleModalLabel">{{mode}} Answers</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span
              aria-hidden="true">&times;</span> </button>
        </div>
        <div class="modal-body pt-0 pb-0 small" *ngIf="modelType==4">
          <div class="container mt-0">
            <div class="form-group">
              <div class="row mb-2">
                <div class="col-xl-3">
                  <label><span>Answer Order</span></label>
                </div>
                <div class="col-xl-3">
                  <div class="text-effect">
                    <input type="text" class="form-control form-control-sm focus-text"
                      onkeypress='return (event.charCode >= 48 && event.charCode <= 57)'
                      [(ngModel)]="answerEntity.answerOrder" maxlength="3" id="answerOrder" autocomplete="nope" />
                  </div>
                </div>
                <div class="col-xl-3">
                  <label><span>Score</span></label>
                </div>
                <div class="col-xl-3">
                  <div class="text-effect">
                    <input type="text" class="form-control form-control-sm focus-text"
                      onkeypress='return ((event.charCode >= 48 && event.charCode <= 57)||event.charCode==32)'
                      [(ngModel)]="answerEntity.score" maxlength="3" id="answerOrder" autocomplete="nope" />
                  </div>
                </div>
                <br>
              </div>
              <div *ngFor="let ans of answerEntity.answerLang;  let i=index">
                <div *ngIf="supportedLanguages.length > i">
                  <div class="row mb-2">
                    <div class="col-xl-3">
                      <label>{{supportedLanguages.length > i ? supportedLanguages[i].name : ''}}</label>
                    </div>
                    <div class="col-xl-9">
                      <div class="text-effect">
                        <input type="text" class="form-control form-control-sm focus-text" pattern="[a-zA-Z][a-zA-Z ]+"
                          [(ngModel)]="ans.langStr" maxlength="100" id="langStr" autocomplete="nope" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      
      <div class="modal-footer">
        <button type="button" (click)="closeWindow()" class="btn btn-secondary btn-sm" data-dismiss="modal"><i
            class="fa fa-times"></i>
          Closefghfhf</button>
        <!-- <button type="submit" class="btn btn-success btn-sm" (click)="saveEntity()"><i class="fa fa-send"></i>
          {{(entity.id==undefined || entity.id=='' || entity.id==0)?'Save':'Update'}} </button> -->
      </div>
    </div>
  </div>
</div>

<!-- modal delte -->

<div class="modal fade" id="myModal_delete" data-backdrop="static" data-keyboard="false" tabindex="-1"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{mode}} Delete</h5>
        <button type="button" class="close" aria-label="Close" data-dismiss="modal" (click)="closeWindow()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <div class="row  mb-2">
            <div class="col-xl-12">
              <p class="text-center">Are you sure want to delete the Record(s) </p>
              <div class="text-center">
                <button type="submit" (click)="confirm(false)" class="btn btn-secondary btn-sm mr-2"
                  data-dismiss="modal"><i class="fa fa-times"></i> close</button>
                <button type="submit" (click)="confirm(true)" class="btn btn-danger btn-sm"><i class="fa fa-trash"></i>
                  Delete</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" (click)="closeWindow()" class="btn btn-secondary btn-sm" data-dismiss="modal"><i
            class="fa fa-times"></i>
          Close</button>
        <!-- <button type="submit" class="btn btn-success btn-sm" (click)="saveEntity()"><i class="fa fa-send"></i>
          {{(entity.id==undefined || entity.id=='' || entity.id==0)?'Save':'Update'}} </button> -->
      </div>
    </div>
  </div>
</div>
<!-- <app-footer></app-footer> -->